import { ANNOTATION_EDIT_URL } from '@backstage/catalog-model';
import { HeaderIconLinkRow, IconLinkVerticalProps, Link } from '@backstage/core-components';
import {  useEntity } from '@backstage/plugin-catalog-react';
import { Card, CardContent, CardHeader, Divider, Grid, IconButton, Typography, makeStyles } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import GitHubIcon from '@mui/icons-material/GitHub';
import DocsIcon from '@material-ui/icons/Description';
import React, { useMemo, useState } from 'react'
import { AboutField } from '@backstage/plugin-catalog';

const useStyles=makeStyles({
    gridItemCard: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 10px)', // for pages without content header
        marginBottom: '10px',
      },
      gridItemCardContent: {
        flex: 1,
      },
})

export default function CustomEntityAboutCard() {
    const { entity } = useEntity();    
    const styles=useStyles();
    const [isRepo, setIsRepo] = useState(
      !entity?.metadata?.annotations?.['terraform.io/organization'] ?? true
    );
    const entityMetadataEditUrl = entity.metadata.annotations?.[ANNOTATION_EDIT_URL];
    const entitySourceLocation = useMemo(() => {
        const sourceLocation = entity.metadata.annotations['backstage.io/source-location'];
        if (sourceLocation && sourceLocation.startsWith('url:')) {
          return sourceLocation?.replace('url:', '');
        }
        return sourceLocation;
      }, [entity.metadata.annotations]);

      const readmeLocation = useMemo(() => {
        let link ='';
        if(isRepo){
            link= entitySourceLocation?.replace("tree", "blob")?.replace("/repo/", "/README.md");
            return link;
        }
        else{
            return entitySourceLocation
        }

      }, [entity.metadata.annotations]);

    

    const viewInSource: IconLinkVerticalProps = {
        label: 'View Source',
        disabled: !entitySourceLocation,
        icon: <GitHubIcon />,
        href: entitySourceLocation,
      };

      const viewInTechDocs: IconLinkVerticalProps = {
        label: 'Readme',
         disabled: !readmeLocation,
        icon: <DocsIcon />,
        href:readmeLocation
      };
    const subHeaderLinks =isRepo? [viewInSource, viewInTechDocs]:[viewInSource];
    
  return (
    <Card className={styles.gridItemCard}>
        <CardHeader
            title='About'
            action={
                <>
                    <IconButton
                         component={Link}
                         aria-label="Edit"
                         disabled={!entityMetadataEditUrl}
                         title="Edit Metadata"
                         to={entityMetadataEditUrl ?? '#'}
                    >
                         <EditIcon />
                    </IconButton>
                </>
            }
             subheader={<HeaderIconLinkRow links={subHeaderLinks}/>}
        />   
        <Divider />
        <CardContent className={styles.gridItemCardContent}>
            <Grid container>
                <AboutField label='Description' gridSizes={{xs:12}}>
                    <Typography>
                        {entity?.metadata?.description || 'No description'}    
                    </Typography>
                </AboutField>
                <AboutField
                    label="Owner"
                    value="No Owner"
                    gridSizes={{ xs: 12, sm: 6, lg: 4 }}
                >
                    <Typography>
                        {entity?.spec?.owner}
                    </Typography>
                </AboutField>
            </Grid>
        </CardContent>
    </Card>
  )
}
